import { IBrandDiscount } from "@faire/web-api/indigofair/data/IBrandDiscount";
import { mapValues } from "@faire/web/common/mapValues";

export const cartHasValidBrandDiscounts = (
  brandDiscounts: Partial<Record<string, IBrandDiscount>>
) => {
  const now = Date.now();

  const discounts = mapValues(brandDiscounts).filter((d) => d!.active);
  return discounts.some((discount) => {
    if (discount.retailer_amount?.amount_cents ?? 0 > 0) {
      return true;
    } else if (
      discount.free_shipping &&
      discount.free_shipping_until &&
      discount.free_shipping_until > now
    ) {
      return true;
    }
    return false;
  });
};
